import { createTheme } from '@mui/material/styles';

const commonPalette = {
    primary: {
        main: '#2196f3',
        light: '#64b5f6',
        dark: '#1976d2',
        contrastText: '#fff',
    },
    secondary: {
        main: '#f50057',
    },
    error: {
        main: '#f44336',
    },
    success: {
        main: '#4caf50',
    },
    warning: {
        main: '#ff9800',
    },
    info: {
        main: '#2196f3',
    },
};

const typography = {
    fontFamily: [
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
    ].join(','),
    h1: {
        fontWeight: 600,
    },
    h2: {
        fontWeight: 600,
    },
    h3: {
        fontWeight: 600,
    },
    button: {
        textTransform: 'none',
        fontWeight: 600,
    },
};

export const lightTheme = createTheme({
    palette: {
        mode: 'light',
        ...commonPalette,
        background: {
            default: '#ffffff',
            paper: '#f8f9fa',
        },
        text: {
            primary: '#000000',
            secondary: '#666666',
        },
    },
    typography,
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 9999, // Pill shape to match CSS
                    padding: '8px 24px',
                },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    borderRadius: 12,
                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                },
            },
        },
    },
});

export const darkTheme = createTheme({
    palette: {
        mode: 'dark',
        ...commonPalette,
        background: {
            default: '#1a1a1a',
            paper: '#2d2d2d',
        },
        text: {
            primary: '#ffffff',
            secondary: 'rgba(255, 255, 255, 0.7)',
        },
        divider: 'rgba(255, 255, 255, 0.12)',
    },
    typography,
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 9999,
                    padding: '8px 24px',
                },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    borderRadius: 12,
                    backgroundImage: 'none', // Remove default gradient overlay in dark mode
                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.4)',
                },
            },
        },
        MuiAppBar: {
            styleOverrides: {
                root: {
                    backgroundImage: 'none',
                    backgroundColor: '#1a1a1a', // Match bg-primary in dark mode
                },
            },
        },
    },
});
